module.exports = __webpack_public_path__ + "img/coins-7.4148eb8e.png";